import { useTheme } from "@mui/material";
import type { FC } from "react";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	recipients: AgentAssignedListItemResponseDTO[];
	onSelect: (advisorId: string) => void;
};

export const ChatRecipientList: FC<Props> = ({ recipients, onSelect }) => {
	const theme = useTheme();

	return (
		<>
			{recipients.map((recipient, index) => (
				<ListRow
					key={recipient.uid}
					title={recipient.name}
					icon={
						<InitialsAvatar
							name={recipient.name}
							photo={recipient.avatar ?? undefined}
							size={theme.chat.avatar.size.md}
							initialsVariant="initials"
						/>
					}
					showChevron={false}
					isLast={index === recipients.length - 1}
					onClick={() => onSelect(recipient.uid)}
				/>
			))}
		</>
	);
};
